
export const TicketStatus = {
  CLOSE: 'CLOSE',
  SUBJECT_WAITING_FOR_RESPONSE: 'SUBJECT_WAITING_FOR_RESPONSE',
  OBJECT_DID_REPLY: 'OBJECT_DID_REPLY',
  CLAIM_SUCCESSFUL: 'CLAIM_SUCCESSFUL',
  CLAIM_REJECT: 'CLAIM_REJECT',
};

export const TicketTypes = {
  CLAIM_CONTRACTOR: 'CLAIM_CONTRACTOR',
  CUSTOMER_SUPPORT: 'CUSTOMER_SUPPORT',
};

export const TicketFields = {
  id: 'id',
  subjectId: 'subjectId',
  subjectType: 'subjectType',
  objectId: 'objectId',
  objectType: 'objectType',
  type: 'type',
  title: 'title',
  content: 'content',
  status: 'status',
  attachments: 'attachments',
  createdByUserId: 'createdByUserId',
  replies: 'replies',
};



// WEBPACK FOOTER //
// ./src/services/ticket/Ticket.Constant.js